import { render } from "./AdminInventory.vue?vue&type=template&id=131c7c00&scoped=true&ts=true"
import script from "./AdminInventory.vue?vue&type=script&lang=ts"
export * from "./AdminInventory.vue?vue&type=script&lang=ts"

import "./AdminInventory.vue?vue&type=style&index=0&id=131c7c00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131c7c00"]])

export default __exports__